const links = [
	{
		name: 'Email',
		meta: 'luiz@luizcavalieri.dev',
		href: 'mailto:luiz@luizcavalieri.dev',
		external: false,
	},
	{
		name: 'GitHub',
		meta: '@luizcavalieri',
		href: 'https://github.com/luizcavalieri',
		external: true,
	},
	{
		name: 'LinkedIn',
		meta: '/in/luizcavalieri',
		href: 'https://linkedin.com/in/luizcavalieri',
		external: true,
	},
	{
		name: 'Writing',
		meta: 'blog ↗',
		href: 'https://blog.luizcavalieri.dev',
		external: true,
	},
]

export const Footer = () => {
	return (
		<footer className="bg-ink text-paper py-20 px-6">
			<div className="max-w-7xl mx-auto">
				{/* Top grid: question + links */}
				<div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr] gap-16 pb-12 border-b border-white/15">
					{/* Left: display question */}
					<p
						className="font-display font-black uppercase leading-none"
						style={{ fontSize: 'clamp(40px, 6vw, 84px)', lineHeight: 0.95 }}
					>
						If anything here resonates — the door is{' '}
						<span className="font-serif italic font-normal normal-case text-hazard">
							open.
						</span>
					</p>

					{/* Right: link list */}
					<ul className="flex flex-col justify-center gap-4">
						{links.map(({ name, meta, href, external }) => (
							<li key={name}>
								<a
									href={href}
									{...(external
										? { target: '_blank', rel: 'noopener noreferrer' }
										: {})}
									className="group flex justify-between items-baseline font-display-cond text-[18px] uppercase text-paper transition-all duration-200 hover:text-hazard hover:pl-3 focus-ring-on-dark"
								>
									<span>{name}</span>
									<span className="font-mono text-[11px] text-paper-2 group-hover:text-hazard transition-colors duration-200">
										{meta}
									</span>
								</a>
							</li>
						))}
					</ul>
				</div>

				{/* Bottom colophon */}
				<div className="flex flex-wrap justify-between items-center gap-2 pt-6 font-mono text-[10px] text-white/55">
					<span>© MMXXVI · L.C.</span>
					<span>Set in Bricolage Grotesque, Fraunces &amp; JetBrains Mono</span>
					<span>Filed in Sydney · Australia</span>
				</div>
			</div>
		</footer>
	)
}
